import React from 'react';
import { Section, FadeIn } from './ui';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <Section className="bg-cream-100 !py-6 sm:!py-12" data-id="element-143">
      <FadeIn data-id="element-144">
        <div className="max-w-2xl mx-auto bg-white rounded-xl sm:rounded-2xl p-6 sm:p-10 text-center shadow-sm border border-cream-200" data-id="element-145">
          <div className="flex justify-center mb-4 sm:mb-6 text-amber-500" data-id="element-146">
            <ShieldCheck size={48} strokeWidth={1.5} className="sm:w-16 sm:h-16" data-id="element-147" />
          </div>

          <h2 className="text-xl sm:text-3xl font-serif text-navy-900 mb-4 sm:mb-6" data-id="element-148">
            GARANTÍA DE 7 DÍAS
          </h2>

          <div className="space-y-2 sm:space-y-4 text-base sm:text-lg text-gray-700" data-id="element-149">
            <p data-id="element-150">Si lees el libro y sientes que no fue lo que esperabas...</p>
            <p className="font-medium text-navy-900 text-xl" data-id="element-151">
              Te devolvemos tu dinero.
            </p>
            <p data-id="element-152">Sin preguntas. Sin complicaciones.</p>
            <p className="pt-4 italic text-gray-600" data-id="element-153">
              Así de seguros estamos de que este libro va a moverte algo por
              dentro.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};